export enum FormFieldExtensionKeys {
  DebouncedValidation = "DebouncedValidation",
  LastDebounce = "LastDebounce",
  DebouncingTrigger = "DebouncingTrigger",
  LastUpdate = "LastUpdate",

  LastDebounceDispatch = "LastDebounceDispatch",
  DebounceDispatchTrigger = "DebounceDispatchTrigger",
}
